module.exports = __webpack_public_path__ + "img/particle_motion_00091.127d09be.png";